<template>
  <div>
    <common-dialog ref="dialog" unit="报工简报" width="1000px" id-key="UserId" @close-saved="$emit('close-saved')" @closed="$emit('onClosed')"
      @details-opened="detailsOpened">
      <template slot="form">
        <el-row style="text-align: center; margin: 15px">
          <el-col :span="6">
            <span class="detail-span">工单数：{{ info.Quantity }}</span>
          </el-col>
          <el-col :span="6">
            <span class="detail-span">产品名称：{{ info.ProductName }}</span>
          </el-col>
          <el-col :span="6">
            <span class="detail-span">规格型号：{{ info.ProductSpec }}</span>
          </el-col>
        </el-row>
        <el-table ref="table" class="table_bottom table-line tb-c-head" :data="tableData" :summary-method="getSummaries" show-summary
          border>
          <el-table-column prop="Sn" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="DocDate" label="报工日期" min-width="110" align="center">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toDateString(row.DocDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="DailyProduction" label="日完工数" min-width="126" align="center">
          </el-table-column>
          <el-table-column prop="BaseQuantity" label="报工主数" min-width="126" align="center">
          </el-table-column>
          <el-table-column prop="SubQuantity" label="报工辅数" min-width="110" align="center">
          </el-table-column>
          <el-table-column prop="DailyProductionRate" label="日完成率" min-width="110" align="center">
          </el-table-column>
          <el-table-column prop="TotalComplete" label="累计完成数" min-width="110" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.TotalComplete }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="TotalCompleteRate" label="累计完成率" min-width="110" align="center">
          </el-table-column>
        </el-table>
      </template>

      <template slot="footer">
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },

  data() {
    return {
      api: require("@/api/production/workDoc").default,
      WorkDocId: null,
      warehouseList: [],
      WarehouseId: null,
      Quantity: null,
      notQuantity: null, // 工单的未入库数 = 工单的需求数量 - 工单的累计入库数
      info: {},
      tableData: [],
      showTextArr: [
        {
          type: "time",
          label: "单据时间",
          startKey: "DocDateStart",
          endKey: "DocDateEnd",
        },
        {
          type: "data",
          label: "客户",
          key: "TradeUnitName",
        },
        {
          type: "data",
          label: "存货",
          key: "ProductName",
        },
      ],
      params: {
        Name: "",
        LoginId: "",
        RoleId: null,
        Status: null,
      },
      ifShow: {
        query: [
          {
            key: "GroupType",
            values: [1, 2],
          },
        ],
        lists: ["ProductNo", "ProductName", "ProductSpec"],
      },
      summaryShow: false,
      total: null,
    };
  },
  methods: {
    detailsOpened(data) {
      console.log("data", data);

      this.api.GetWorkDocStInDocList(data).then((res) => {
        console.log("GetWorkDocStInDocList", res);
        if (res.Code === 0) {
          this.info = res.Data;
          this.tableData = res.Data.InDocProduct;
        }
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 2 || index === 3 || index === 4) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }
        }
      });

      return sums;
    },
    summaryFunc(param) {
      console.log("summaryFunc", param.columns);
      const { columns, data } = param;
      var fields = ["DailyProduction", "BaseQuantity", "SubQuantity"]; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find((x) => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field];
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    close() {
      this.WarehouseId = null;
      this.WorkDocId = null;
      this.warehouseList = [];
      this.Quantity = null;
      this.notQuantity = null;
      this.$refs.dialog.close(true);
    },
  },
};
</script>
